import getEnv from "./getEnv";

/** Product helpers */

export const PLUGIN_MAPPING = {
	wordpress: "plugin",
	typo3: "typo3-extension",
	shopify: "shopify-app",
};

export const GL_NUMBERS = {
	googleDocsAddon: "82111",
	premium2025: "82112",
	woocommerceSEO2025: "82113",
	yoastSeoAiPlus: "82114",
	allPluginsPlusAllCourses: "80001",
	allPlugins: "82109",
	premiumNew: "82120",
	premiumOld: "82101",
	local: "82103",
	news: "82104",
	wooCommerce: "82105",
	video: "82102",
	localWooCommerceDeprecated: "82106",
};

/**
 * Returns the URL of the shop.
 *
 * @returns {string} The URL of the shop.
 */
export function getShopUrl() {
	return getEnv( "SHOP_URL", "https://yoast.test" );
}

